import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonDirective, Button } from 'primeng/button';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TabsModule } from 'primeng/tabs';
import { CheckboxComponent } from '@components/checkbox';
import {FormBuilder} from '@components/form-builder/form-builder';
import { OldMapComponent } from '@components/old-map/old-map.component';
import { Field, FieldService } from '@6grain/masofa-monolith-api-client/crop-monitoring';
import {
  ModalEditFieldPolygon
} from '@app/pages/electronic-field-map/pages/fields/passport/forms/modal-edit-field-polygon/modal-edit-field-polygon';
import {ConfirmationService, MessageService} from 'primeng/api';
import {ConfirmDialog} from 'primeng/confirmdialog';
import {Toast} from 'primeng/toast';
@Component({
  selector: 'app-modal-field-edit-extended',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonDirective,
    Button,
    TranslatePipe,
    TabsModule,
    CheckboxComponent,
    FormBuilder,
    OldMapComponent,
    ConfirmDialog,
    Toast,
  ],
  templateUrl: './modal-field-edit-extended.html',
  styleUrls: ['./modal-field-edit-extended.scss'],
  providers:[ConfirmationService, MessageService]
})
export class ModalFieldEditExtended extends ModalEditFieldPolygon{
  model: Field;
  fields: any[] = [];
  activeTab: string = '0';
  currentPolygon: any;

  /** True when hosted in {@link FieldDetailsDialogComponent} edit tab (not a standalone DynamicDialog). */
  get isEmbeddedInShell(): boolean {
    return !!(this.config?.data as { embedded?: boolean } | undefined)?.embedded;
  }
  constructor(
    override  ref: DynamicDialogRef,
    override  config: DynamicDialogConfig,
    override  fieldService: FieldService,
    override  confirmationService: ConfirmationService,
    override  translate: TranslateService,
    override  messageService: MessageService,
  ) {
    super(ref, config, fieldService, confirmationService, translate, messageService);
    this.model = { ...(this.config.data?.model || {}) };
    this.fields = this.config.data?.fields || [];
    this.multiPolygonJson = this.config.data?.multiPolygonJson || [];
    this.currentPolygon = this.model.polygonJson;
    this.formData = this.model;
  }


}
